// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__7jPap","inner":"Hero_inner__+f89G","title":"Hero_title__DJPwu","subtitle":"Hero_subtitle__G-ZGN"};